import React from "react";
import { Mail } from "lucide-react";
import { GithubIcon } from "../components/BrandIcons";

export const Header: React.FC = () => {
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-background/80 backdrop-blur-sm border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#" className="text-sm font-semibold tracking-tight text-foreground hover:text-primary transition-colors duration-300">
          Akbar
        </a>
        <nav className="flex items-center gap-6">
          <a
            href="mailto:akbarwidya.dev@gmail.com"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300 flex items-center gap-1.5"
          >
            <Mail className="w-4 h-4" />
            <span className="hidden sm:inline">Email</span>
          </a>
          <a
            href="https://github.com/akbar-widya"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300 flex items-center gap-1.5"
          >
            <GithubIcon className="w-4 h-4" />
            <span className="hidden sm:inline">GitHub</span>
          </a>
        </nav>
      </div>
    </header>
  );
};
